<template>
    <div class="container" v-if="!isMobile()">
        <div class="d-flex space-between mb-5">
          <b-link v-for="(post,index) in articulos" :key="post.id" :to="'/blog/articulo/' + post.id" data-aos="zoom-in" data-aos-duration="1000" :data-aos-delay="index*200-100" href="" class="card-article">
            <p>{{post.nombre_categoria}}</p>
            <h1>{{post.titulo}}</h1>
            <b-link :to="'blog/articulo/' +  post.id">Leer más <b-icon icon="chevron-right" class="ml-2 chevron" style="bottom:0px"></b-icon></b-link>
          </b-link>
        </div>
      </div>
      <div class="container mb-4" v-else>
        <div class="row">
          <template v-for="(post,index) in articulos" >
            <div :key="post.id" class="col-lg-12 card-article">
            <p>{{post.nombre_categoria}}</p>
              <h1 class="mb-4">{{post.titulo}}</h1>
              <b-link :to="'blog/articulo/' + post.id">Leer más <b-icon icon="chevron-right" class="ml-2 chevron"></b-icon></b-link>
            </div>
            <div :key="post.id" class="col-lg-12">
              <hr v-if="index < articulos.length-1"/>
            </div>
          </template>
        </div>
        <h1 class="titulo_precio">Solicita tu demostración</h1>
        <b-button to="/about" pill size="sm" class="my-2 my-sm-0 btnDemo" type="submit">Solicitar demo</b-button>
      </div>
</template>

<script>

import postsApi from "../api/posts";

export default {
    data() {
        return {
            articulos:[]
        }
    },
    methods: {
      getPosts(){
            
        let parametros = {paginate:false,items_to_show:2,order:"desc",order_by:"id",fijo:true,activo:true};
        postsApi
        .getPosts(parametros)
        .then(response => {
          this.articulos = response.data.data;
        }).catch(err => {
          console.log("Ocurrio un error al cargar los articulos.");
        });
          },
          isMobile: function() {
              var check = false;
              //console.log(window.screen.width);
              if(window.screen.width < 769){
                  return check=true;
              }
          }
    },
    created() {
        this.getPosts();
    }
  }
</script>

<style scoped>
 .banner-1{
    padding:33px;
  }
  .banner-2{
    padding:50px;
  }
  
  /* boton subir
  */
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  .post-date h4{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 15px;

    margin:auto 0 auto 5px;
    color: #828282;  
  }

  .post-date p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin:auto 0 auto 25px;
    color: #BDBDBD;
  }

  h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140.62%;
    color: #1E2245;
    text-align: left;
    padding-top:40px;
    padding-bottom: 40px;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 50px auto 90px auto;
  }

  /**Estilo beneficios seccion */

  .bg-enterate {
    background: url("/static/images/bg_azul_categoria.svg") repeat-x;
  }

  .titulo_enterate {
    font-family: Muli-Extrabold;
    font-style: normal;
    font-weight: normal;
    font-size: 50px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #1E2245;
    padding-top:130px;
  }

  .imagen_enterate {
    margin-right: auto;
    margin-left: auto;
    margin-top:-50px;
  }

  .imagen_enterate img {
    width: 100%;
  }

  
  .titulo_articulos {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    align-items: center;
    text-align: center;

    color: #1E2245;
    padding-bottom: 40px;
    margin-top:20px;
  }

  .texto_articulos {
    font-family: Muli;
    font-style: normal;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.2px;color: #1E2245;
    padding-bottom:40px;
  }

  .testimonio{
      padding-top:205px ;
      padding-bottom:195px;
  }
  .title-testimonio{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #1E2245;
  }

  .text-testimonio{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 19px;
    text-align: center;
    color: #1E2245;
    margin-bottom:30px;
  }

  .article-block{
      background-color: #1E2245;
      color:#fff;
      text-align: center;
      padding: 50px;
      width: 100%;
  }

  .article-block p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }

  .article-block h1{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 50px;
    margin-bottom:50px;
    margin-top:30px;
  }

  .article-block a{
      color:#fff;
  }
  .divider-02 {
    height: 5px;
    width: 20%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-right: auto;
    margin-left: auto;
    margin-bottom: 10px;
  }

  .card-article{
    width: 49%;
    background: #FFFFFF;
    box-shadow: 1px 3px 5px 1px rgba(107, 127, 153, 0.2);
    border-radius: 15px;
    padding: 40px 78px 40px 78px;
    text-align: justify;
    text-decoration: none;
   
  }

  .card-article p{
    font-family: Muli;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #2DB9D1;
    text-decoration: none;
  }

  .card-article h1{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 42px;
    margin-bottom:60px;
    color: #1E2245;
    height: 210px;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .card-article h1:hover{
    text-decoration: underline;
  }

  .card-article h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    color: #828282;
  }

  @media(max-width: 768px){

    .banner-1{
      margin-top:20px;
      width: 100%;
    }
    .banner-2{
      width: 100%;
    }

    .post-date h4{
      font-family: Muli;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 15px;

      margin:auto 0 auto 5px;
      color: #828282;  
    }

    .post-date p{
      font-family: Muli;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      margin:auto 0 auto 25px;
      color: #BDBDBD;
    }

    .titulo_enterate {
      font-weight: 800px;
      font-size: 24px;
      line-height: 40px;
      align-items: center;
      text-align: center;
      letter-spacing: 0.2px;
      color: #1E2245;
      padding-top:100px;
      padding-bottom: 0px;
    }

    .divider-01 {
      margin: 60px auto 80px auto;
      width: 70%;
    }
    
    .article-block{
      text-align: left;
      padding: 50px;
      width: 100%;
      margin-left:0px;
      margin-right: 0px;
  }

  .article-block h1{
    width: 80%;
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 0px;
  }

  .divider-02 {
    height: 5px;
    width: 40%;
    background-color: #E8404E;
    border-radius: 3px;
    margin: 25px 0px 50px 0px;
  }

  .card-article{
    width: 100%;
    box-shadow: 0px 0px 0px 0px rgba(107, 127, 153, 0.2);
    border-radius: 0px;
    padding: 20px;
   
  }

  .card-article a{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: #2DB9D1;
  }

  .card-article h1{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 30px;
    line-height: 42px;
    margin-bottom:0px;
    color: #1E2245;
    
  }

  .btnDemo {
    font-family: Muli-Bold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        color: #FFF ;
        background: #2DB9D1;
        border-color: #2DB9D1;
            width: 100%; 
            margin-bottom: 25px;
            padding-bottom: 13px;
            padding-top:13px;
            border-radius: 14px;
        }

         .titulo_precio {
        font-family: Muli;
        font-style: normal;
        font-weight: 800;
        font-size: 26px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2245;
        margin-bottom:30px;
        margin-top:80px;
        }

  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>